<template functional>
    <component :is="props.component" v-bind="props.userdata" @close="props.close" />
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-modal-presenter')
export default class VrmModalPresenter extends Vue {}
</script>
